export default __webpack_public_path__ + "static/media/checkers-4-rMAX.db2fc840.jpg";